import React, { useState, cloneElement, memo } from 'react';
import PropTypes from 'prop-types';

import { compact } from '../lib/nodash';
import { Box, Tabs as GTabs, Tab as GTab, Heading } from 'grommet';

const TabTitle = ({ children, last, isActive }) => (
  <Box
    pad="medium"
    flex={true}
    fill
    border={compact(
      [{ side: 'bottom', size: 'small' }].concat(
        last ? null : { side: 'right', size: 'small' }
      )
    )}
    background={isActive ? 'black' : undefined}
  >
    <Heading
      level={4}
      textAlign="center"
      style={{ opacity: isActive ? 1 : 0.5, transition: '0.5s opacity' }}
    >
      {children}
    </Heading>
  </Box>
);
TabTitle.propTypes = {
  children: PropTypes.node,
  last: PropTypes.bool,
  isActive: PropTypes.bool,
  tabCount: PropTypes.number,
};

export const Tabs = ({ children = [] }) => {
  const [activeTab, setActiveTab] = useState(0);
  const nonNilChildren = children.filter(
    (x) => x !== null && typeof x !== 'undefined'
  );
  return (
    <GTabs
      onActive={setActiveTab}
      activeIndex={activeTab}
      justify="stretch"
      alignControls="stretch"
      flex
    >
      {nonNilChildren.map((x, i) => (
        <Box key={i} basis={`${100 / nonNilChildren.length}%`}>
          {cloneElement(x, {
            isActive: i === activeTab,
            isLast: i === nonNilChildren.length - 1,
            tabCount: nonNilChildren.length,
          })}
        </Box>
      ))}
    </GTabs>
  );
};
Tabs.propTypes = {
  children: PropTypes.node,
};

export const Tab = ({ children, title, isActive, isLast, tabCount }) => {
  return (
    <GTab
      plain
      basis={`${100 / tabCount}%`}
      title={
        <TabTitle last={isLast} isActive={isActive}>
          {title}
        </TabTitle>
      }
    >
      {children}
    </GTab>
  );
};
Tab.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  isActive: PropTypes.bool,
  isLast: PropTypes.bool,
  tabCount: PropTypes.number,
};

export default memo(Tabs);
